import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { globalSpacing } from "../../src/theme";
import styles from "./ChatBot.module.css";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { useConversation } from "../../services/query/mutation";
import useConversationProvider from "../../store/provider/AuthProvider";
import Markdown from "react-markdown";

export default function ChatBotComp() {
  const [propmt, setPrompt] = useState("");
  const { mutateAsync, data, isLoading } = useConversation();
  const { conversationList, addBotMessage, addUserMessage } =
    useConversationProvider();

  const handleSend = async () => {
    if (!propmt) return;
    addUserMessage(propmt);
    setPrompt(() => "");
    await mutateAsync(propmt);
  };

  useEffect(() => {
    if (data && data?.result) {
      addBotMessage(data.result);
    }
  }, [data]);

  return (
    <Box px={globalSpacing}>
      <Box className={styles.chatBotContainer}>
        <Typography className={styles.botTitle}>Chat Bot</Typography>
        <Box className={styles.botContent}>
          {conversationList.map((item, index) => (
            <Box
              key={index}
              className={styles.chatContainer}
              style={{
                alignSelf: item.author === "Bot" ? "flex-start" : "flex-end",
              }}
            >
              <Markdown>{item.message}</Markdown>
            </Box>
          ))}
        </Box>
        <Box className={styles.textAreaContainer}>
          <TextField
            multiline
            fullWidth
            value={propmt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            placeholder="Enter a prompt here"
            InputProps={{
              style: {
                borderRadius: "12px",
              },
            }}
            maxRows={4}
          />
          <Button disabled={isLoading} onClick={handleSend}>
            <SendRoundedIcon className={styles.sendIcon} fontSize="large" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
